import React, { useState } from 'react';
import api from '../../utils/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Check, X, Loader2, UserPlus } from 'lucide-react';

export const RichiestePanel = ({ richieste, onReload }) => {
  const [actingId, setActingId] = useState(null);

  const act = async (id, action) => {
    setActingId(id);
    try {
      await api.post(`/booking/richieste/${id}/${action}`);
      toast.success(action === 'approva' ? 'Prenotazione approvata e cliente avvisato' : 'Richiesta rifiutata');
      onReload();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
    finally { setActingId(null); }
  };

  if (!richieste.length) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-5" data-testid="richieste-panel">
      <div className="flex items-center gap-2 mb-3">
        <UserPlus size={15} className="text-amber-600" />
        <h3 className="text-sm font-semibold text-amber-800">Richieste di prenotazione da approvare ({richieste.length})</h3>
      </div>
      <div className="space-y-2">
        {richieste.map(r => (
          <div key={r.id} className="bg-white rounded-lg border border-amber-100 px-3 py-2.5 flex items-center gap-3 flex-wrap" data-testid={`richiesta-${r.id}`}>
            <div className="flex-1 min-w-[200px]">
              <p className="text-sm font-semibold text-slate-800">{r.nome} <span className="text-[10px] font-medium text-amber-600 bg-amber-100 px-1.5 py-0.5 rounded-full ml-1">nuovo contatto</span></p>
              <p className="text-xs text-slate-500">{r.data} ore {r.ora} · {r.motivo || 'nessun motivo'} · {r.telefono} · {r.email}</p>
            </div>
            <div className="flex gap-1.5">
              <Button size="sm" className="h-8 text-xs bg-emerald-600 hover:bg-emerald-700 text-white" disabled={actingId === r.id}
                onClick={() => act(r.id, 'approva')} data-testid={`approva-${r.id}`}>
                {actingId === r.id ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} className="mr-1" />} Approva
              </Button>
              <Button size="sm" variant="outline" className="h-8 text-xs text-red-600 border-red-200 hover:bg-red-50" disabled={actingId === r.id}
                onClick={() => act(r.id, 'rifiuta')} data-testid={`rifiuta-${r.id}`}>
                <X size={12} className="mr-1" /> Rifiuta
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
